






















































































































































































































































































































































































import Component from "vue-class-component";
import Vue from "vue";
import {
  PolicyFundDto,
  PolicyValuesDto,
  PolicyDto,
  PolicyRoleDto,
  PolicyBenefitGroupDto
} from "@/api/ClientPortalApiClient";
import ApiFactory from "@/api/ApiFactory";
import AlertService from "@/services/alert.service";
import BackButton from "@/components/BackButton.vue";
import { LoadingSpinnerService } from "@/store";
import { FormatDate } from "@/filters/FormatDate";

@Component({
  components: {
    BackButton
  }
})
export default class PolicyDetails_Protection extends Vue {
  private policyDetails: PolicyDto = new PolicyDto();
  private policyBenefits: PolicyBenefitGroupDto[] | null = [];
  private policyRoles: PolicyRoleDto[] | null = [];
  private policyId: number | undefined;
  private contactId: number | undefined;

  async created() {
    LoadingSpinnerService.Show("Loading policy details...");
    try {
      this.policyId = parseInt(this.$route.params.policyId);
      this.contactId = parseInt(this.$route.params.contactId);
      await this.getPolicyDetails();
      await this.getPoliciesBenefits();
      await this.getPoliciesRoles();
      LoadingSpinnerService.Hide();
    } catch (e) {
      LoadingSpinnerService.Failure(
        "Failed to load policy details. Please try again."
      );
    }
  }

  private async getPolicyDetails() {
    if (!this.policyId || !this.contactId)
      throw new Error("Request is not valid");
    const api = ApiFactory.CreateDataClient();
    const result = await api.policies_GetByPolicyId(
      this.contactId,
      this.policyId
    );
    this.policyDetails = result || new PolicyDto();
  }

  private async getPoliciesBenefits() {
    if (!this.policyId) throw new Error("Policy id not valid");
    const api = ApiFactory.CreateDataClient();
    const result = await api.benefits_Policies(this.policyId);
    this.policyBenefits = result || [];
  }

  private async getPoliciesRoles() {
    if (!this.policyId || !this.contactId)
      throw new Error("Request is not valid");
    const api = ApiFactory.CreateDataClient();
    const result = await api.policies_GetRolesByPolicyId(
      this.contactId,
      this.policyId
    );
    this.policyRoles = result || [];
  }

  get policyEndDateString(): string {
    return new Date(this.policyDetails.maturityDate) <= new Date("01/01/1900")
      ? "Open Ended"
      : FormatDate.format(this.policyDetails.maturityDate);
  }
}
